import { getAssetUrlByRelativePath } from '../services/http-requests';
import '../styles/blogpreview.css';

const BlogPreview = ({title, undertext, relativePathImg, onClick, width, height}) => {
  return (
    <div 
      className='blogpreview-container' 
      style={{
        backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0) 50%, transparent 100%), url(${getAssetUrlByRelativePath(relativePathImg)})`, 
        cursor: onClick ? "pointer" : "auto",
        width: width,
        height: height,
      }}
      onClick={onClick}
    >
      <div className='blogpreview-text-container'>
        <h1 
          className='blogpreview__title'
        >
          {title}
        </h1>
        <p className='blogpreview__under-text text'>{undertext}</p>
      </div>
    </div>
  )
}

export default BlogPreview
